import { Link, useLocation } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/utils/cn';

interface SidebarItem {
  label: string;
  path: string;
  icon: LucideIcon;
  exact?: boolean;
}

interface SidebarProps {
  items: SidebarItem[];
}

export const isSidebarItemActive = (pathname: string, item: SidebarItem) => {
  if (item.exact) {
    return pathname === item.path;
  }

  return pathname === item.path || pathname.startsWith(`${item.path}/`);
};

export const Sidebar = ({ items }: SidebarProps) => {
  const location = useLocation();

  return (
    <aside className="hidden h-full w-64 shrink-0 self-stretch overflow-hidden border-r border-slate-200 bg-white md:sticky md:top-0 md:block">
      <nav className="space-y-1.5 p-4">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = isSidebarItemActive(location.pathname, item);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex items-center gap-3 rounded-lg border px-4 py-3 text-sm font-semibold transition',
                isActive
                  ? 'border-[rgb(var(--accent-solid))/0.25] bg-[rgb(var(--accent-solid))/0.10] text-[rgb(var(--accent-solid))]'
                  : 'border-transparent text-slate-600 hover:border-slate-200 hover:bg-slate-50 hover:text-slate-950'
              )}
            >
              <Icon className="h-5 w-5" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
};
